import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { MessageService } from '../service-ui/message.service';
import { HttpClient} from '@angular/common/http';
import {catchError, map, tap} from 'rxjs/operators';
import { StartupService } from '../service-ui/startup.service';
import {environment} from "../../environments/environment";
import {NotificationsService} from "./notifications.service";
import {EcommerceProduct} from "../../model/EcommerceProduct";
import {AbstractLiveDataService} from "./abstract-live-data.service";
import {ObjectAttachRequest} from "./data-service";
import {EcommerceOrder} from "../../model/EcommerceOrder";

@Injectable()
export class EcommerceProductService extends AbstractLiveDataService<EcommerceProduct> {

  constructor(private httpa: HttpClient, private messageServicea: MessageService, private startupServicea: StartupService, protected notificationsService: NotificationsService) {
    super(httpa, messageServicea, startupServicea, notificationsService);
    notificationsService.setEcommerceProductService(this);
    notificationsService.startNotification();
  }

  makeObjectInstance(args: any): EcommerceProduct {
    return new EcommerceProduct(args);
  }

  getLoggingObjectTypeName (): string {
    return "EcommerceProduct";
  }

  supportsParallel(): boolean {
    return true;
  }

  getURLEndPoint (): string {
    return "ecommerceproduct";
  }

  private handleErrorX<T> (role: string, operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      this.loadingState[role] = 'INITIAL';

      // TODO: send the error to remote logging infrastructure
      console.error(error, operation); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getLinkData(): any[] {
    return [
      { action: 'Link', objectIdPropertyName: 'ecommerceconnection_ID', serviceName: 'ecommerceConnectionService', arrayProperty: 'ecommerceProducts', objectProperty: 'ecommerceConnection'},
      { action: 'Link', objectIdPropertyName: 'product_ID', serviceName: 'productService', arrayProperty: 'ecommerceProducts', objectProperty: 'product'},
    ];
  }

  updateRemoteProduct (ecommerceProduct: EcommerceProduct): Observable<EcommerceProduct> {
    const url = `${environment.apiBaseURL}/${this.getURLEndPoint()}/updateremoteproduct`;
    this.messageService.add(`updateRemoteProduct EcommerceProductService ${JSON.stringify(ecommerceProduct)}`);
    return this.http.put(url, ecommerceProduct, this.startupService.getHttpOptions()).pipe(
      tap(_ => this.log(`updateRemoteProduct EcommerceProductService ${JSON.stringify(ecommerceProduct)}`)),
      catchError(this.handleErrorX<any>(`error updateRemoteProduct EcommerceProductService ${JSON.stringify(ecommerceProduct)}}`))
    );
  }
}
